'use strict';

function getRemainingTime(timezone) {
    const now = new Date();

    const formatter = new Intl.DateTimeFormat('sv-SE', {
        timeZone: timezone,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
  
    const dateTimeStr = formatter.format(now).replace(' ', 'T');
    const tzDate = new Date(dateTimeStr);

    const midnight = new Date(tzDate);
    midnight.setHours(24, 0, 0, 0);

    const diffMs = midnight - tzDate;

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    return {
        hours,
        minutes,
        seconds,
        formatted: `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    };
}

function updateTimer() {
    const $bankAffiliation = $('.bank-affiliation');

    if(!$bankAffiliation.length) {
        clearInterval(window.BANK_AFFILIATION_TIMER);
        return;
    }
    const timezone = $bankAffiliation.attr('data-timezone') || 'Chile/Continental';
    const remainingTime = getRemainingTime(timezone);

    if(remainingTime.hours <= 0 && remainingTime.minutes <= 0 && remainingTime.seconds <= 0) {
        clearInterval(window.BANK_AFFILIATION_TIMER);
        $bankAffiliation.find('.js-bank-affiliation-timer').text('00:00:00');
        return;
    }
    $bankAffiliation.find('.js-bank-affiliation-timer').text(remainingTime.formatted);
}

function initHandlers() {
    //subscriptions
    $(document).on('click', '.js-tab-buy-one-pdp', function () {
        $('.js-bank-affiliation').show();
    })

    $(document).on('click', '.js-tab-subscription-pdp', function () {
        $('.js-bank-affiliation').hide();
    })

    //Sol
    $(document).on('change', '.js-sol-switch input', function () {
        if($(this).is(':checked')) {
            $('.js-bank-affiliation').hide();
        } else {
            $('.js-bank-affiliation').show();
        }
    })
}

module.exports = function () {
    window.BANK_AFFILIATION_TIMER = setInterval(updateTimer, 1000);
    initHandlers();
}